import axios from "axios";

export const getInteresInvoice = async (period) => {
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';

  const config = {
    method: "GET",
    url: `http://${url}:4000/api/v1/boletaDigital/interesInvoice?period=${period}`,
    //url: `http://localhost:4000/api/v1/boletaDigital/interesInvoice?period=${period}`,

    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
